import type { ReactElement } from 'react';
import { useNavigate } from 'react-router';
import { Button, Mascot, cn } from '@xdocs/ui';
import { useWebT } from '../i18n/useWebT.js';
import styles from './NotFoundPage.module.css';

/** 404 catch-all (design/app/36-not-found.html). */
export function NotFoundPage(): ReactElement {
  const { t } = useWebT();
  const navigate = useNavigate();

  return (
    <div className={cn(styles['page'])}>
      <Mascot pose="concerned" size={120} alt="" muted animate={false} />
      <p className={cn(styles['eyebrow'])}>{t('web:notFound.eyebrow')}</p>
      <h1 className={cn(styles['title'])}>{t('web:notFound.title')}</h1>
      <p className={cn(styles['description'])}>{t('web:notFound.description')}</p>
      <div className={cn(styles['actions'])}>
        <Button variant="primary" onClick={() => void navigate('/documents')}>
          {t('web:notFound.cta')}
        </Button>
        <Button variant="secondary" onClick={() => void navigate('/discover')}>
          {t('web:notFound.ctaSecondary')}
        </Button>
      </div>
    </div>
  );
}
